import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import breadcrumb from "../../Assets/breadcrumb.png";
import { routes } from "../../App";
import "./Header.scss";
import { Button } from "primereact/button";
import {
  getIsAdvSearchOngoing,
  getCardsData,
} from "../../Store/Masters/MastersSelectors";
import { useTranslation } from "react-i18next";

const BreadcrumbsMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMasterAdvSearchOngoing = useSelector(getIsAdvSearchOngoing);
  const cardsData = useSelector(getCardsData);
  const [currPath, setCurrPath] = useState(null);
  const [parentRoute, setParentRoute] = useState("*");
  const [currChildPath1, setCurrChildPath1] = useState(null);
  const { t } = useTranslation("master");
  const [totalMasterCount, setTotalMasterCount] = useState(null);

  useEffect(() => {
    let count = 0;
    if (cardsData && cardsData.length > 0) {
      cardsData.forEach((card) => {
        if (card.data && card.data.length > 0) {
          count = count + card.data.length;
        }
      });
    }
    setTotalMasterCount(count);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsData]);
  const handleRouteClick = () => {
    navigate(`/${parentRoute}`);
  };

  useEffect(() => {
    //reset initial settings
    setParentRoute("*");
    setCurrPath(null);
    setCurrChildPath1(null);

    routes.forEach((el) => {
      const routing = `/${el.path}`;

      if (el.headerName && routing === location.pathname) {
        setParentRoute(el.path);
        setCurrPath(el.headerName);
      } else if (location.pathname.includes(routing) && el.children) {
        setParentRoute(el.path);
        const parentRoute = el.children.find((i) => i.path === "");
        const childPath = location.pathname.split("/")[2];
        const childRoute = el.children.find((i) => i.path === childPath);
        setCurrPath(parentRoute.headerName);
        childRoute && setCurrChildPath1(childRoute.headerName);
      }
    });
  }, [location.pathname]);

  return (
    <div className="flex flex-wrap align-items-center">
      <Button
        link
        className="font-semibold text-base pr-2 cursor-pointer pl-0"
        style={{ color: "#1D2965" }}
        onClick={handleRouteClick}
        data-testid="parent-route-button"
      >
        {currPath}
      </Button>
      {currPath === "All Masters" && !currChildPath1 && (
        <div
          className="font-normal text-sm mt-1"
          data-testid="total-master-count"
        >
          {t("Total")} {totalMasterCount}
        </div>
      )}
      {currChildPath1 && (
        <img
          src={breadcrumb}
          alt="breadcrmb"
          width="16px"
          height="16px"
          data-testid="breadcrumb-icon"
        />
      )}
      <p className="font-normal text-base pl-2 pr-2">{currChildPath1}</p>
      {isMasterAdvSearchOngoing && (
        <>
          <img
            src={breadcrumb}
            alt="breadcrmb"
            width="16px"
            height="16px"
            data-testid="search-breadcrumb-icon"
          />
          <p className="font-normal text-base pl-2">Search</p>
        </>
      )}
    </div>
  );
};
export default BreadcrumbsMenu;
